export default __webpack_public_path__ + "static/media/11.51a572af.png";